import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitContact = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
};

export const getSupportInfo = async () => {
  const { data } = await axios.get(`${API}/support-info`);
  return data;
};

export const SUPPORT = {
  email: "saveudealsco@gmail.com",
  phone: "2489813752",
  phoneDisplay: "+1 (248) 981-3752",
};
